module.exports = __webpack_public_path__ + "img/tricycleInf.ccc7e968.webp";